import { render } from "./YourDetailsLDY.vue?vue&type=template&id=945055cc&scoped=true"
import script from "./YourDetailsLDY.vue?vue&type=script&lang=js"
export * from "./YourDetailsLDY.vue?vue&type=script&lang=js"

import "./YourDetailsLDY.vue?vue&type=style&index=0&id=945055cc&lang=scss"
import "./YourDetailsLDY.vue?vue&type=style&index=1&id=945055cc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945055cc"]])

export default __exports__